import wsspIcon from '../../../assets/img/chat/wssp.png';
import igIcon from '../../../assets/img/chat/ig.png';
import wsspBussinessIcon from '../../../assets/img/chat/wssp-api.webp';
import messengerIcon from '../../../assets/img/chat/messenger.png';

export function getMultichatServiceIcon(service: ChatServiceType) {
  if (service === 'INSTAGRAM') {
    return igIcon;
  }

  if (service === 'WHATSAPP_WEB') {
    return wsspIcon;
  }

  if (service === 'WHATSAPP_API') {
    return wsspBussinessIcon;
  }

  if (service === 'FB_MESSENGER') {
    return messengerIcon;
  }

  return '';
}
